<template>
  <v-content class="px-0 mx-0">
    <v-container fluid class="primary">
      <v-row>
        <v-col>
          <v-container style="max-width: 1200px;">
            <h1 class="mt211-header secondary--text">Service Providers</h1>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container style="max-width: 1200px;">
      <v-row class="pt-8">
        <v-col cols="12" md="7">
          Select Region by clicking on the map below:
          <v-img :src="mapImage" :lazy-src="mapImage">
            <svg style="width: 100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 899 512">
          
          <image xlink:href="new-map.png" style="width: 899px;"></image>
          
          <!-- Northwestern Region -->
          <a @click.prevent="setRegion('Northwestern')" xlink:title="Northwestern">
            <g>
              <polygon class="image-mapper-shape" points="99 191 125 204 169 217 176 166 294 180 339 168 360 123 382 120 382 40 336 37 39 25 39 28 43 171 52 182 78 181"></polygon>
            </g>
          </a>
          
          <!-- Central Region -->
          <a @click.prevent="setRegion('Central')" xlink:title="Central">
            <g>
              <polygon class="image-mapper-shape" points="384 246 332 234 317 280 282 284 242 245 224 178 309 185 341 171 391 40 818 28 841 258 777 275 730 250 411 265"></polygon>
            </g>
          </a>
          
          <!-- Southeastern Region -->
          <a @click.prevent="setRegion('Southeastern')" xlink:title="Southeastern">
            <g>
              <polygon class="image-mapper-shape" points="602 436 710 429 856 418 830 266 748 277 726 255 608 258 478 263 477 304 476 325 471 353 446 394 428 416 453 432 477 434"></polygon>
            </g>
          </a>
          
          <!-- Southwestern Region -->
          <a @click.prevent="setRegion('Southwestern')" xlink:title="Southwestern">
            <g>
              <polygon class="image-mapper-shape" points="223 488 185 434 166 363 181 282 205 177 285 234 361 237 393 261 435 269 459 271 468 277 464 372 422 429 356 482"></polygon>
            </g>
          </a>
          
          <!-- Western Region -->
          <a @click.prevent="setRegion('Western')" xlink:title="Western">
            <g>
              <polygon class="image-mapper-shape" points="3 259 136 383 164 364 205 178 185 170 169 216 73 187 73 185 41 181"></polygon>
            </g>
          </a>
          
        </svg>
          </v-img>
        </v-col>
        <v-col cols="12" md="5" class="pt-6 text-area text-center">
          <v-select
            v-model="agencyData.region.data"
            :items="agencyData.region.items"
            label="Choose Region"
            hide-details
            outlined
            filled
          >
            <template v-slot:selection="{ attrs, item, parent, selected }">
              <v-chip
                style="width: calc(100% - 8px);"
                v-if="item === item"
                v-bind="attrs"
                :color="region_color(item)"
                :input-value="selected"
                label
                dark
              >
                <span class="pr-2">
                  {{ item }}
                </span>
              </v-chip>
            </template>
            <template v-slot:item="{ index, item }">
              <v-chip
                style="width: calc(100% - 8px);"
                :color="region_color(item)"
                dark
                label
              >
                 {{ item }}
              </v-chip>
            </template>
          </v-select>
          <v-divider class="my-4" color="#B3B3B3"></v-divider>
          <template v-if="agencyData.region.data === 'Southwestern'">
            <v-btn
              :disabled="disableEntry"
              class="mb-4"
              block
              target="_blank"
              href="https://webapp.icarol.com/pub/VerifyResourcePublic2.aspx?org=2043&r=0&k=d2bb0cb2-b2d0-460a-848a-575084fcb4c1"
              color="primary"
            >
            Click Here to Add a New Agency/Program(s)
            </v-btn>
            <v-btn
              :disabled="disableEntry"
              block
               @click="openDialog('Southwestern')"
              color="primary"
            >
            Click Here to Update Your Agency/Program(s)
            </v-btn>
          </template>
          <template v-else-if="agencyData.region.data === 'Southeastern'">
            <v-btn
              :disabled="disableEntry"
              class="mb-4"
              block
              target="_blank"
              href="https://na0.icarol.com/pub/VerifyResourcePublic2.aspx?org=86001&r=0&k=8165e63d-73e9-4aae-811a-b1be24355fa1"
              color="primary"
            >
              Click Here to Add a New Agency/Program(s)
            </v-btn>
            <v-btn
              :disabled="disableEntry"
              block
              @click="openDialog('Southeastern')"
              color="primary"
            >
              Click Here to Update Your Agency/Program(s)
            </v-btn>
          </template>
          <template v-else-if="agencyData.region.data === 'Central'">
            <v-btn
              :disabled="disableEntry"
              class="mb-4"
              block
              target="_blank"
              href="https://na0.icarol.com/pub/VerifyResourcePublic2.aspx?org=2063&r=0&k=561c7073-d131-4ea3-8956-3ab33fc68aaf"
              color="primary"
            >
              Click Here to Add a New Agency/Program(s)
            </v-btn>
            <v-btn
              :disabled="disableEntry"
              block 
              @click="openDialog('Central')"
              color="primary"
            >
              Click Here to Update Your Agency/Program(s)
            </v-btn>
          </template>
          <template v-else-if="agencyData.region.data === 'Western'">
            <v-btn
              :disabled="disableEntry"
              class="mb-4"
              block
              target="_blank"
              href="https://na0.icarol.com/pub/VerifyResourcePublic2.aspx?org=2092&r=0&k=4b3abc2f-ceba-4d8e-a903-e8072db3cd6e"
              color="primary"
            >
              Click Here to Add a New Agency/Program(s)
            </v-btn>
            <v-btn
              :disabled="disableEntry"
              block
              @click="openDialog('Western')" 
              color="primary"
            >
              Click Here to Update Your Agency/Program(s)
            </v-btn>
          </template>
          <template v-else-if="agencyData.region.data === 'Northwestern'">
            <v-btn
              :disabled="disableEntry"
              class="mb-4"
              block
              target="_blank"
              href="https://na0.icarol.com/pub/VerifyResourcePublic2.aspx?org=61156&r=0&k=300ed2ac-57f9-4116-96e2-7484be8129ce"
              color="primary"
            >
              Click Here to Add a New Agency/Program(s)
            </v-btn>
            <v-btn
              :disabled="disableEntry"
              block
              @click="openDialog('Northwestern')"
              color="primary"
            >
              Click Here to Update Your Agency/Program(s)
            </v-btn>
          </template>
          <v-dialog v-model="dialogVisible" max-width="600px">
          <v-card>
            <v-card-title>Update Your Agency/Program Information</v-card-title>
            <v-card-text>
              <p>
                Thank you for connecting with Montana 211 to update your agency and programs. Please fill out the information below and we will send you the information that we currently have on file in our database via email so you can easily update.
              </p>
              <h1 v-if="successMessage" class="success-message">Submission successful! This dialog will close shortly.</h1>
              <v-form v-else ref="form">
                <v-text-field 
                  label="Your Name" 
                  v-model="formData.name" 
                  :rules="[v => !!v || 'Name is required']" 
                  required
                ></v-text-field>
                <v-text-field 
                  label="Agency Name" 
                  v-model="formData.agency" 
                  :rules="[v => !!v || 'Agency Name is required']" 
                  required
                ></v-text-field>
                <v-text-field 
                  label="Location" 
                  v-model="formData.location" 
                  :rules="[v => !!v || 'Location is required']" 
                  required
                ></v-text-field>
                <v-text-field 
                  label="Email" 
                  v-model="formData.email" 
                  type="email" 
                  :rules="[
                    v => !!v || 'Email is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                  ]" 
                  required
                ></v-text-field>
                <v-text-field 
                  label="Phone" 
                  v-model="formData.phone" 
                  type="tel" 
                  :rules="[v => !!v || 'Phone is required']" 
                  required
                ></v-text-field>
                <v-textarea 
                  label="Comments" 
                  v-model="formData.comments"
                ></v-textarea>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="submitForm">Submit</v-btn>
              <v-btn text @click="dialogVisible = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

          <v-divider class="my-5" color="#B3B3B3"></v-divider>
          <policy></policy>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import Policy from "../components/Policy.vue";
import mapImage from "../../../images/new-map.png";
import axios from "axios";
export default {
  components: {
    Policy
  },
  data: () => ({
    mapImage: mapImage,
    regionToggle: undefined,
    search: null,
    dialogVisible: false,
    successMessage: false,
    formData: {
      name: '',
      agency: '',
      location: '',
      email: '',
      phone: '',
      comments: ''
    }
  }),
  computed: {
    agencyData: {
      get() {
        return this.$store.state["agencyData"];
      },
      set(value) {
        this.$store.commit("set_agencyData", value);
      }
    },
    update: {
      get() {
        return this.$store.state["update"];
      },
      set(value) {
        this.$store.commit("set_update", value);
      }
    },
    disableEntry() {
      if (!this.agencyData.region.data) {
        return true;
      }
      return false;
    }
  },
  watch: {
    agencyData: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.agencyData = this.agencyData;
      }
    }
  },
  methods: {
    openDialog(region) {
      console.log(region);
      this.dialogVisible = true;
    },
    setRegion(regionTitle) {
      this.agencyData.region.data = regionTitle;
    },
    submitForm() {
    if (this.$refs.form.validate()) {
      // Assign the region to the form data
      this.formData.region = this.agencyData.region.data;

      const formData = new FormData();

      // Populate FormData with fields
      formData.append('region', this.agencyData.region.data);
      formData.append('name', this.formData.name);
      formData.append('agency', this.formData.agency);
      formData.append('location', this.formData.location);
      formData.append('email', this.formData.email);
      formData.append('phone', this.formData.phone);
      formData.append('comments', this.formData.comments);

      // Send the form data to the PHP script
      axios.post('/includes/send_update.php', formData)
        .then(response => {
          console.log('Email sent successfully!', response.data);
          this.successMessage = true; // Show success message

          // Hide success message and close dialog after 5 seconds
          setTimeout(() => {
            this.successMessage = false;
            this.dialogVisible = false;
          }, 5000);
        })
        .catch(error => {
          console.error('Error sending email:', error);
        });
    }
   },
    add_agency() {
      this.update = false;
      this.$router.push({ name: "agency" });
    },
    update_agency() {
      this.update = true;
      this.$router.push({ name: "agency" });
    },
    get_item_number(item) {
      if (item == "Helena") {
        return "";
      } else {
        // var HelenaNum = this.agencyData.region.items.indexOf('Helena');

        var i = this.agencyData.region.items.indexOf(item);

        // if (HelenaNum < i) {
        // return i + '.';
        // } else {
        return 1 + i + ".";
        // }
      }
    },
    region_color(region) {
      let color = "black";
      if (region === "Southeastern") {
        color = "#0066A0";
      }
      if (region === "Northwestern") {
        color = "#35A193";
      }
      if (region === "Western") {
        color = "#5F9DCF";
      }
      if (region === "Southwestern") {
        color = "#161D45";
      }
      if (region === "Central") {
        color = "#2C4F9E";
      }
      return color;
    }
  }
};
</script>
<style>
.text-area h3 {
  font-size: 18px;
  font-weight: bolder;
  font-family: "Montserrat", sans-serif;
  text-transform: uppercase;
}

.text-area p {
  margin-bottom: 10px !important;
}

.text-area {
  font-family: "Droid Serif", serif;
  color: #666666;
  font-size: 12px;
}

.btn-toggle-vertical {
  flex-direction: column;
  width: 100%;
}
.region-selected::before {
  background-color: white;
  opacity: 1 !important;
}
.image-mapper-shape {
   fill: rgba(0, 0, 0, 0);
}
</style>
